import { TipOutput } from '@/api/gql/graphql';
import { create } from 'zustand';

interface TipByCategory {
  name: string;
  _id: string;
}

type TipByCategoryStore = {
  selectedTip: TipByCategory | null;
  setSelectedTip: (tip: TipByCategory | null) => void;
  isOpenModal: boolean;
  setIsOpenModal: (isOpenModal: boolean) => void;
  isOpenForm: boolean;
  setIsOpenForm: (isOpenForm: boolean) => void;
  isEditMode: boolean;
  setIsEditMode: (isEditMode: boolean) => void;
  tip: TipOutput | null;
  setTip: (tip: TipOutput | null) => void;
  statusFilter: string[];
  setStatusFilter: (statusFilter: string[]) => void;
};

export const useTipStore = create<TipByCategoryStore>((set) => ({
  selectedTip: null,
  setSelectedTip: (tip) => set({ selectedTip: tip }),
  isOpenModal: false,
  setIsOpenModal: (isOpenModal) => set({ isOpenModal }),
  isOpenForm: false,
  setIsOpenForm: (isOpenForm) => set({ isOpenForm }),
  isEditMode: false,
  setIsEditMode: (isEditMode) => set({ isEditMode }),
  tip: null,
  setTip: (tip) => set({ tip }),
  statusFilter: [],
  setStatusFilter: (statusFilter) => set({ statusFilter }),
}));